<template>
  <BaseDialog :is-open="true" type="basic" class="pt-4">
    <div class="flex flex-col md:flex-row items-center md:gap-2 pb-4">
      <div class="relative flex items-center justify-center p-3">
        <BaseIcon size="22" class="z-20 text-on-primary">home_work</BaseIcon>
        <BaseShape shape="7-sided-cookie" class="absolute inset-0 text-primary" />
      </div>
      <h2 class="text-title-large md:text-headline-small">Wähle eine Organisation</h2>
    </div>
    <div class="flex flex-col gap-2">
      <BaseCard
        type="filled"
        v-for="organization in organizationStore.organizations"
        :key="organization.id"
        @click="setOrganization(organization.id)"
        class="relative group overflow-hidden grow flex-row gap-4 p-4 items-center cursor-pointer"
      >
        <p class="text-body-large md:text-title-medium grow">
          {{ organization.name }}
        </p>
        <BaseIconButton
          color="standard"
          icon="login"
          width="narrow"
          size="XS"
          class="self-center"
        />
        <BaseStateLayer type="elevated" />
      </BaseCard>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useOrganizationStore } from '../../../stores/organization.store'
import BaseCard from '@/core/components/base/card/BaseCard.vue'
import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
import { useDialog } from '@/core/components/base/dialog/use-dialog'

const router = useRouter()

const organizationStore = useOrganizationStore()

const { closeDialog } = useDialog()

const setOrganization = async (id: string) => {
  await organizationStore.switchOrganization(id)
  closeDialog()

  router.replace(history.state?.redirect || '/')
}
</script>
